import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

const STATUS_OPTIONS = ['upcoming', 'ongoing', 'selesai', 'batal'];

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', location: '', tanggal_mulai: '', biaya: 0, rekening_info: '', max_peserta: '' });
  const [expandedId, setExpandedId] = useState(null);
  const [rsvpList, setRsvpList] = useState([]);
  const [kuotaEdit, setKuotaEdit] = useState({});

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await api.get('/touring-events/');
      setEvents(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post('/touring-events/admin', {
        ...form,
        max_peserta: form.max_peserta === '' ? null : parseInt(form.max_peserta, 10),
      });
      setShowCreate(false);
      setForm({ title: '', description: '', location: '', tanggal_mulai: '', biaya: 0, rekening_info: '', max_peserta: '' });
      fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal membuat event');
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/touring-events/admin/${id}`, { status });
      fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update status');
    }
  };

  const saveKuota = async (id) => {
    const val = kuotaEdit[id];
    try {
      await api.put(`/touring-events/admin/${id}`, {
        max_peserta: val === '' || val === undefined ? null : parseInt(val, 10),
      });
      fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update kuota');
    }
  };

  const toggleExpand = async (id) => {
    if (expandedId === id) {
      setExpandedId(null);
      return;
    }
    try {
      const res = await api.get(`/touring-events/admin/${id}/rsvp-list`);
      setRsvpList(res.data);
      setExpandedId(id);
    } catch (err) {
      alert('Gagal mengambil daftar RSVP');
    }
  };

  const updateRsvp = async (rsvpId, changes) => {
    try {
      await api.put(`/touring-events/admin/rsvp/${rsvpId}`, changes);
      const res = await api.get(`/touring-events/admin/${expandedId}/rsvp-list`);
      setRsvpList(res.data);
      fetchEvents(); // refresh participant_count juga di list utama
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal update RSVP');
    }
  };

  const deleteRsvp = async (rsvpId) => {
    if (!window.confirm('Hapus data RSVP ini secara permanen? Aksi ini tidak bisa dibatalkan.')) return;
    try {
      await api.delete(`/touring-events/admin/rsvp/${rsvpId}`);
      const res = await api.get(`/touring-events/admin/${expandedId}/rsvp-list`);
      setRsvpList(res.data);
      fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus RSVP');
    }
  };

  const deleteEvent = async (id, title) => {
    if (!window.confirm(`Hapus event "${title}" secara permanen? Semua data RSVP & checkpoint terkait ikut terhapus. Aksi ini tidak bisa dibatalkan.`)) return;
    try {
      await api.delete(`/touring-events/admin/${id}`);
      fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus event');
    }
  };

  const inputStyle = { background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '10px 12px', color: '#F0EDE4', fontSize: 13, width: '100%' };
  const labelStyle = { fontSize: 11, color: '#8B92A0', marginBottom: 4, display: 'block' };

  return (
    <Layout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic' }}>Event Touring</h1>
        <button
          onClick={() => setShowCreate(!showCreate)}
          style={{ background: '#D02127', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 6, fontWeight: 700, fontSize: 13, cursor: 'pointer' }}
        >
          {showCreate ? 'Batal' : '+ Buat Event'}
        </button>
      </div>

      {showCreate && (
        <form onSubmit={handleCreate} style={{ background: '#1C2128', border: '1px solid #262b33', padding: 20, borderRadius: 8, marginBottom: 24, display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div>
            <label style={labelStyle}>Judul Event</label>
            <input type="text" placeholder="Judul event" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Deskripsi</label>
            <textarea placeholder="Deskripsi" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={2} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Lokasi</label>
            <input type="text" placeholder="Lokasi" value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Tanggal & Waktu Mulai</label>
            <input type="datetime-local" value={form.tanggal_mulai} onChange={(e) => setForm({ ...form, tanggal_mulai: e.target.value })} required style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Biaya (Rp, isi 0 kalau gratis)</label>
            <input type="number" placeholder="0" value={form.biaya} onChange={(e) => setForm({ ...form, biaya: parseInt(e.target.value) || 0 })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Info Rekening (kalau ada biaya)</label>
            <input type="text" placeholder="Info rekening" value={form.rekening_info} onChange={(e) => setForm({ ...form, rekening_info: e.target.value })} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Kuota Maksimal Peserta (kosongkan = tidak dibatasi)</label>
            <input type="number" min="1" placeholder="Contoh: 30" value={form.max_peserta} onChange={(e) => setForm({ ...form, max_peserta: e.target.value })} style={inputStyle} />
          </div>
          <button type="submit" style={{ background: '#2B6996', color: '#fff', border: 'none', padding: 12, borderRadius: 6, fontWeight: 700, cursor: 'pointer' }}>
            Simpan Event
          </button>
        </form>
      )}

      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {events.map((ev) => (
            <div key={ev.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, overflow: 'hidden' }}>
              <div style={{ padding: 18, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                <div>
                  <p style={{ fontWeight: 800, fontSize: 15 }}>{ev.title}</p>
                  <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                    {ev.location || '-'} · {new Date(ev.tanggal_mulai).toLocaleDateString('id-ID')} · Rp {ev.biaya?.toLocaleString('id-ID') || 0}
                  </p>
                  <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 4 }}>
                    Peserta: {ev.participant_count || 0}{ev.max_peserta ? ` / ${ev.max_peserta}` : ' (tanpa batas)'}
                  </p>
                  <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 8 }}>
                    <span style={{ fontSize: 11, color: '#8B92A0' }}>Kuota:</span>
                    <input
                      type="number"
                      min="1"
                      placeholder="tanpa batas"
                      defaultValue={ev.max_peserta || ''}
                      onChange={(e) => setKuotaEdit((prev) => ({ ...prev, [ev.id]: e.target.value }))}
                      style={{ width: 90, background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '4px 8px', borderRadius: 4, fontSize: 11 }}
                    />
                    <button
                      onClick={() => saveKuota(ev.id)}
                      style={{ background: 'rgba(43,105,150,0.15)', color: '#2B6996', border: 'none', padding: '4px 10px', borderRadius: 4, fontSize: 11, cursor: 'pointer' }}
                    >
                      Simpan
                    </button>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                  <select
                    value={ev.status}
                    onChange={(e) => updateStatus(ev.id, e.target.value)}
                    style={{ background: '#12151A', border: '1px solid #262b33', color: '#F0EDE4', padding: '6px 10px', borderRadius: 4, fontSize: 12 }}
                  >
                    {STATUS_OPTIONS.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                  <button
                    onClick={() => toggleExpand(ev.id)}
                    style={{ background: 'transparent', border: '1px solid #262b33', color: '#8B92A0', padding: '6px 14px', borderRadius: 4, fontSize: 12, cursor: 'pointer' }}
                  >
                    {expandedId === ev.id ? 'Tutup' : 'Lihat RSVP'}
                  </button>
                  <button
                    onClick={() => deleteEvent(ev.id, ev.title)}
                    style={{ background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '6px 14px', borderRadius: 4, fontSize: 12, cursor: 'pointer' }}
                  >
                    Hapus
                  </button>
                </div>
              </div>
              {expandedId === ev.id && (
                <div style={{ borderTop: '1px solid #262b33', padding: 18, overflowX: 'auto' }}>
                  {rsvpList.length === 0 ? (
                    <p style={{ color: '#8B92A0', fontSize: 13 }}>Belum ada yang RSVP.</p>
                  ) : (
                    <table style={{ width: '100%', minWidth: 560, fontSize: 12, borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid #262b33', textAlign: 'left' }}>
                          <th style={{ padding: 8, color: '#8B92A0' }}>Nama</th>
                          <th style={{ padding: 8, color: '#8B92A0' }}>Ikut</th>
                          <th style={{ padding: 8, color: '#8B92A0' }}>Bayar</th>
                          <th style={{ padding: 8, color: '#8B92A0' }}>Hadir</th>
                          <th style={{ padding: 8, color: '#8B92A0' }}>Aksi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rsvpList.map((r) => (
                          <tr key={r.id} style={{ borderBottom: '1px solid #20242c' }}>
                            <td style={{ padding: 8, fontWeight: 700 }}>{r.member_name}</td>
                            <td style={{ padding: 8 }}>
                              <button
                                onClick={() => updateRsvp(r.id, { ikut: !r.ikut })}
                                title="Klik buat toggle ikut/batalkan (membebaskan kuota kalau dibatalkan)"
                                style={{
                                  background: r.ikut ? 'rgba(74,222,128,0.15)' : 'rgba(139,146,160,0.15)',
                                  color: r.ikut ? '#4ADE80' : '#8B92A0',
                                  border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 11,
                                }}
                              >
                                {r.ikut ? 'Ya' : 'Batal'}
                              </button>
                            </td>
                            <td style={{ padding: 8 }}>
                              <button
                                onClick={() => updateRsvp(r.id, { status_bayar: r.status_bayar === 'lunas' ? 'belum' : 'lunas' })}
                                style={{
                                  background: r.status_bayar === 'lunas' ? 'rgba(74,222,128,0.15)' : 'rgba(139,146,160,0.15)',
                                  color: r.status_bayar === 'lunas' ? '#4ADE80' : '#8B92A0',
                                  border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 11,
                                }}
                              >
                                {r.status_bayar}
                              </button>
                            </td>
                            <td style={{ padding: 8 }}>
                              <button
                                onClick={() => updateRsvp(r.id, { hadir: !r.hadir })}
                                style={{
                                  background: r.hadir ? 'rgba(43,105,150,0.15)' : 'rgba(139,146,160,0.15)',
                                  color: r.hadir ? '#2B6996' : '#8B92A0',
                                  border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 11,
                                }}
                              >
                                {r.hadir ? '✓ Hadir' : 'Belum'}
                              </button>
                            </td>
                            <td style={{ padding: 8 }}>
                              <button
                                onClick={() => deleteRsvp(r.id)}
                                title="Hapus permanen data RSVP ini"
                                style={{ background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '4px 10px', borderRadius: 4, cursor: 'pointer', fontSize: 11 }}
                              >
                                Hapus
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
